






















import { Component, Vue } from 'vue-property-decorator';
import TitleContainer from '@/components/common/TitleContainer.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import MainButton from '@/main-components/common/MainButton.vue';
import Img from '@/main-components/common/Img.vue';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    TitleContainer,
    MainButton,
    Img,
  },
  metaInfo(this: PremiumCancel): MetaInfo {
    return {
      title: 'Cancel Subscription |',
      meta: [
        ...seoDefault({
          title: 'Cancel Subscription | Mysoalan',
          description:
            'We are passionate people that want to help all teachers out there to prepare paper exams for any subject. So that teachers can focus more on teaching instead of hassling drafting exam papers while meeting the deadline.',
        }),
      ],
    };
  },
})
export default class PremiumCancel extends Vue {}
